import React from 'react';

export default function RemoteSitePowerControls({ siteName, enabled, blocked, execution }) {
  return <section className="phone-remote__screen-routines phone-remote__site-routines" aria-label="Site power options">
    <strong>{siteName || 'Selected site'} · All areas</strong>
    <p>Runs the saved site routine. Defaults start or stop every Screen with a configured routine. Individual failures are recorded and later steps continue.</p>
    <div className="phone-remote__compact-actions">
      <button type="button" className="phone-remote__action-btn" disabled={!enabled || blocked || execution.busy} onClick={() => execution.run('startup')}>Site Startup</button>
      <button type="button" className="phone-remote__action-btn phone-remote__action-btn--warn" disabled={!enabled || blocked || execution.busy} onClick={() => execution.run('shutdown')}>Site Shutdown</button>
    </div>
    {!enabled && <p>Choose a target and load its site to enable these controls.</p>}
  </section>;
}
